import { isApprovalOverdue, isConfirmationNotRequired } from 'src/services/helpers/approval.helper'
import { getCutoffDate, isDateValue, toUtcDay } from 'src/services/app/util.service'
import {
  CONFIRMATION_FILTER_FIELDS,
  CONFIRMATION_SORT_PAGINATION_FIELDS,
} from 'src/services/consts/confirmations.const'

export function getRequiresConfirmationApprovals(approvals, today) {
  if (!approvals) return []
  return approvals.filter((approval) => isApprovalOverdue(approval, today))
}

export function getNextConfirmationDate(approvals, today) {
  if (!approvals) return null
  const upcomingDates = approvals
    .filter(
      (approval) =>
        approval.active &&
        isDateValue(approval.nextUserConfirmation) &&
        !isConfirmationNotRequired(approval) &&
        !isApprovalOverdue(approval, today)
    )
    .map((approval) => toUtcDay(approval.nextUserConfirmation))
  if (!upcomingDates.length) return null
  return new Date(Math.min(...upcomingDates))
}

export function filterConfirmations(confirmations, filterBy) {
  if (!confirmations) return []

  const searchTerm = filterBy.search ? filterBy.search.toLowerCase() : null
  const createdCutoffDate = getCutoffDate(filterBy.dateCreatedRange, false)
  const lastConfirmationCutoffDate = getCutoffDate(filterBy.lastConfirmationRange, false)

  return confirmations.filter((confirmation) => {
    const matchesSearch =
      !searchTerm ||
      confirmation.companyName?.toLowerCase().includes(searchTerm) ||
      confirmation.productName?.toLowerCase().includes(searchTerm)

    const matchesdateCreated =
      !createdCutoffDate || new Date(confirmation.dateCreated) >= createdCutoffDate
    const matchesLastConfirmationDate =
      !lastConfirmationCutoffDate ||
      new Date(confirmation.lastUserConfirmation || confirmation.dateCreated) >=
        lastConfirmationCutoffDate

    return matchesSearch && matchesdateCreated && matchesLastConfirmationDate
  })
}

export function getDefaultFilter() {
  return {
    ...CONFIRMATION_FILTER_FIELDS,
  }
}

export function getDefaultSort() {
  return {
    ...CONFIRMATION_SORT_PAGINATION_FIELDS,
  }
}
